module.exports = ".page {\n  background: #f8f9fa;\n  height: 100vh;\n  padding: 30px;\n}\n\n.navbar {\n  border-bottom: 1px solid lightgray;\n}\n"